import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { I18N_KEYS } from "../languages/PlaceHolder.js";
import { useEffect } from "react";
import { setBrowserTitle } from "../utilities/codes.js";

const NotFound = () => {
    const { t } = useTranslation();
    useEffect(() => {
        setBrowserTitle("Not Found")
    }, [])

    return (
        <>
            {/* 404 Content Section */}
            <section className="py-20 px-6 bg-accent min-h-[60vh] flex items-center">
                <div className="common-container text-center">
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                    >
                        <motion.h2
                            className="text-9xl md:text-[12rem] font-black text-primary mb-4"
                            animate={{
                                scale: [1, 1.05, 1],
                            }}
                            transition={{
                                duration: 2,
                                repeat: Infinity,
                                ease: "easeInOut"
                            }}
                        >
                            404
                        </motion.h2>

                        <motion.h3
                            className="text-3xl md:text-4xl font-bold text-primary mb-4"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.3, duration: 0.6 }}
                        >
                            {t(I18N_KEYS.PAGENOTFOUND)}
                        </motion.h3>

                        <motion.p
                            className="text-lg md:text-xl text-gray-600 mb-8 max-w-2xl mx-auto"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.5, duration: 0.6 }}
                        >
                            {t(I18N_KEYS.PAGENOTFOUNDMSG)}
                        </motion.p>

                        <motion.div
                            className="flex flex-col sm:flex-row gap-4 justify-center items-center"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: 0.7, duration: 0.6 }}
                        >
                            <Link
                                to="/"
                                className="bg-primary text-accent px-8 py-4 rounded-full text-lg font-semibold hover:bg-primary/90 transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform"
                            >
                                {t(I18N_KEYS.GOTO)} {t(I18N_KEYS.HOMEPAGENAME)}
                            </Link>
                            <Link
                                to="/contact"
                                className="border-2 border-primary text-primary px-8 py-4 rounded-full text-lg font-semibold hover:bg-primary hover:text-accent transition-colors shadow-lg hover:shadow-xl transform hover:scale-105 transition-transform"
                            >
                                {t(I18N_KEYS.CONTACTUSPAGENAME)}
                            </Link>
                        </motion.div>

                        {/* Quick Links */}
                        <motion.div
                            className="mt-12 pt-8 border-t border-gray-200"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ delay: 0.9, duration: 0.6 }}
                        >
                            <p className="text-gray-600 mb-4">{t(I18N_KEYS.LOOKFOR)}:</p>
                            <div className="flex flex-wrap justify-center gap-4">
                                <Link
                                    to="/about"
                                    className="text-primary hover:text-secondary font-medium transition-colors"
                                >
                                    {t(I18N_KEYS.ABOUTPAGENAME)}
                                </Link>
                                <span className="text-gray-400">•</span>
                                <Link
                                    to="/gallery"
                                    className="text-primary hover:text-secondary font-medium transition-colors"
                                >
                                    {t(I18N_KEYS.GALERYPAGENAME)}
                                </Link>
                                <span className="text-gray-400">•</span>
                                <Link
                                    to="/dignitaries"
                                    className="text-primary hover:text-secondary font-medium transition-colors"
                                >
                                    {t(I18N_KEYS.DIGNATARIESPAGENAME)}
                                </Link>
                                <span className="text-gray-400">•</span>
                                <Link
                                    to="/contact"
                                    className="text-primary hover:text-secondary font-medium transition-colors"
                                >
                                    {t(I18N_KEYS.CONTACTUSPAGENAME)}
                                </Link>
                            </div>
                        </motion.div>
                    </motion.div>
                </div>
            </section>
        </>
    );
}

export default NotFound